import { render, staticRenderFns } from "./DataVisualisation.vue?vue&type=template&id=499aadad&scoped=true"
import script from "./DataVisualisation.vue?vue&type=script&lang=js"
export * from "./DataVisualisation.vue?vue&type=script&lang=js"
import style0 from "./DataVisualisation.vue?vue&type=style&index=0&id=499aadad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499aadad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499aadad')) {
      api.createRecord('499aadad', component.options)
    } else {
      api.reload('499aadad', component.options)
    }
    module.hot.accept("./DataVisualisation.vue?vue&type=template&id=499aadad&scoped=true", function () {
      api.rerender('499aadad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/data-visualisation-tab/DataVisualisation.vue"
export default component.exports